import styled from 'styled-components';

export const PageContainer = styled.div`
  margin: 0 1em;
  position: relative;
`;

export const Header = styled.div`
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  text-align: center;
`;

export const SubHeader = styled.div`
  margin-bottom: 32px;
  text-align: center;
`;
